import RestrictToRole from "./RestrictToRole";

export default RestrictToRole